import React from 'react'
import { Main } from './components'

const Inventory = () => <Main />

export default Inventory

